import { isEqual } from 'lodash';
import { ADD_NOTIFICATION, CLEAR_ALL_NOTIFICATION, CLEAR_NOTIFICATION } from './actions';

const notifications = (state = [], action = {}) => {
	switch (action.type) {
		case ADD_NOTIFICATION: {
			const {
				payload: { notification, params },
			} = action;
			if (state.find((details) => details.notification === notification && isEqual(params, details.params))) {
				return state;
			}
			return [
				{
					id: state.length + 1,
					notification: action.payload.notification,
					params: action.payload.params,
				},
				...state,
			];
		}
		case CLEAR_NOTIFICATION: {
			return state.filter((notification) => notification.id !== action.payload.id);
		}
		case CLEAR_ALL_NOTIFICATION: {
			return [];
		}

		default:
			return state;
	}
};

export default notifications;
